<template>
  <div class="col-12 col-md-6 form-group form-group-sm">
    <label class="label" for="emularSensorDeContacto"
      >Emular Sensor de Contacto</label
    >
    <multiselect-item
      id="emularSensorDeContacto"
      v-model="emularSensorDeContacto"
      :custom-label="label"
      :options="options"
      placeholder="Emular Sensor de Contacto"
      track-by="id"
    ></multiselect-item>
  </div>
</template>

<script>
export default {
  name: "EmularSensorDeContacto",
  data: () => ({
    options: [
      {
        id: 0,
        nombre: "No requerido",
      },
      {
        id: 1,
        nombre: "Por movimiento",
      },
      {
        id: 2,
        nombre: "Por 12V",
      },
      {
        id: 3,
        nombre: "Por 24V",
      },
    ],
  }),
  methods: {
    label(opcion) {
      return opcion.nombre;
    },
  },
  computed: {
    emularSensorDeContacto: {
      get() {
        return this.$store.state.Contratos.NuevoContrato.emularSensorDeContacto;
      },
      set(val) {
        this.$store.commit(
          "Contratos/NuevoContrato/setEmularSensorDeContacto",
          val,
        );
      },
    },
  },
};
</script>

<style scoped></style>
